import { FORM_FACTORS_MAP } from '../../constants';
import { FormFactor } from '../../types';

export const getScreenType = (): FormFactor => {
  const width = window.innerWidth;

  if (width < 480) {
    return FORM_FACTORS_MAP.MOBILE;
  }
  if (width < 1024) {
    return FORM_FACTORS_MAP.TABLET;
  }

  return FORM_FACTORS_MAP.DESKTOP;
};
